import { createFeatureSelector, createSelector } from '@ngrx/store';
import { QueryResultsModel } from '../../_base/crud';
import { LinkGroupsState } from '../_reducers/link-group.reducers';
import { LinkGroup } from '../_models/link-group.model';

export const selectLinkGroupsState = createFeatureSelector<LinkGroupsState>('linkGroups');

export const selectLinkGroupById = (linkGroupId: number) =>
  createSelector(selectLinkGroupsState, (linkGroupsState) =>
    linkGroupsState.linkGroups.find((linkGroup) => linkGroup.id === linkGroupId),
  );

export const selectLinkGroupsPageLoading = createSelector(
  selectLinkGroupsState,
  (linkGroupsState) => {
    return linkGroupsState.listLoading;
  },
);

export const selectLinkGroupsShowInitWaitingMessage = createSelector(
  selectLinkGroupsState,
  (linkGroupsState) => linkGroupsState.showInitWaitingMessage,
);

export const selectLinkGroupError = createSelector(
  selectLinkGroupsState,
  (linkGroupsState) => linkGroupsState.error,
);

export const selectLinkGroupLatestSuccessfullAction = createSelector(
  selectLinkGroupsState,
  (linkGroupsState) => linkGroupsState.latestSuccessfullyAction,
);

export const selectAllLinkGroups = createSelector(
  selectLinkGroupsState,
  (linkGroupsState) => linkGroupsState.linkGroups,
);

export const selectLinkGroupsInStore = createSelector(selectLinkGroupsState, (linkGroupsState) => {
  const items = (linkGroupsState.ids as number[])
    .map((id) => linkGroupsState.entities[id])
    .filter((item): item is LinkGroup => item !== undefined);
  return new QueryResultsModel(items, linkGroupsState.totalCount);
});

export const selectHasLinkGroupsInStore = createSelector(selectLinkGroupsState, (queryResult) => {
  return queryResult.totalCount;
});
